import * as Comp from './content-titlte.styles'

import {
  DISPLAY_NAME,
  type ScopedProps,
  useContentContext,
} from '../../content'
import { ContentIcon } from '../content-icon'

type ContentTitleProps = {
  children: React.ReactNode
  testID?: string
}

export function ContentTitle(props: ContentTitleProps) {
  const { children, testID, __scopeContent } =
    props as ScopedProps<ContentTitleProps>

  const { size, type } = useContentContext(DISPLAY_NAME, __scopeContent)

  const behaviorProps = {
    numberOfLines: 1,
    ellipsizeMode: 'tail',
  } as const

  return (
    <Comp.Container type={type} testID={testID}>
      <Comp.Title {...behaviorProps} size={size}>
        {children}
      </Comp.Title>
      {type === 'interactive' && (
        <ContentIcon
          symbol="rdicon-chevron-right"
          color="colorTextNeutralDefault"
        />
      )}
    </Comp.Container>
  )
}
